<script setup lang="ts">
import CircleCheckIcon from '@/assets/icons/shared/circle/check.svg';
import UiButton from '@/modules/ui/components/ui/UiButton.vue';
import UiSpinner from '@/modules/ui/components/ui/UiSpinner.vue';

defineProps<{
  loading?: boolean;
  noIcon?: boolean;
  iconOnly?: boolean;
  disabled?: boolean;
}>();
</script>

<template>
  <UiButton
    :disabled="loading || disabled"
    :shape="iconOnly ? 'square' : 'auto'"
    :aria-label="iconOnly ? $t('ui.common.button.save') : undefined"
  >
    <UiSpinner
      v-if="loading"
      v-prefix="!iconOnly"
      color="white"
    />
    <CircleCheckIcon
      v-else-if="!noIcon || iconOnly"
      v-prefix="!iconOnly"
    />
    <span v-if="!iconOnly">{{ $t('ui.common.button.save') }}</span>
  </UiButton>
</template>
